import React from "react";
const DrawerClosee = (props) => {
  const { onClick } = props;

  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7.95911" r="7" fill="#E03923" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.8613 10.3474C4.89878 10.3724 4.94284 10.3857 4.98791 10.3857C5.01784 10.3858 5.04749 10.3799 5.07514 10.3685C5.10279 10.357 5.12791 10.3402 5.14906 10.319L7.09334 8.37473L9.03763 10.319C9.05877 10.3402 9.08389 10.357 9.11154 10.3685C9.1392 10.3799 9.16884 10.3858 9.19877 10.3857C9.24385 10.3857 9.28791 10.3724 9.32539 10.3474C9.36287 10.3223 9.39208 10.2867 9.40933 10.2451C9.42658 10.2034 9.43109 10.1576 9.4223 10.1134C9.4135 10.0692 9.39179 10.0286 9.35992 9.99673L7.41563 8.05245L9.35993 6.10815C9.40267 6.06541 9.42668 6.00745 9.42668 5.94701C9.42668 5.88657 9.40267 5.8286 9.35993 5.78586C9.31719 5.74313 9.25923 5.71912 9.19878 5.71912C9.13834 5.71912 9.08038 5.74313 9.03764 5.78586L7.09334 7.73016L5.14904 5.78586C5.10631 5.74313 5.04834 5.71912 4.9879 5.71912C4.92746 5.71912 4.8695 5.74313 4.82676 5.78586C4.78402 5.8286 4.76001 5.88657 4.76001 5.94701C4.76001 6.00745 4.78402 6.06541 4.82676 6.10815L6.77106 8.05245L4.82677 9.99673C4.79489 10.0286 4.77319 10.0692 4.76439 10.1134C4.7556 10.1576 4.76011 10.2034 4.77736 10.2451C4.79461 10.2867 4.82382 10.3223 4.8613 10.3474Z"
        fill="white"
      />
    </svg>
  );
};

export default DrawerClosee;
